import myAxios from "./axiositeachWrapper";
import Config from "../_config/config";

/**
 * One entry of the nodefork error-code registry
 * (nodefork/src/utils/error-codes/error-code-registry.ts). Codes are what
 * students see inside friendly error messages ("...share code ATL-1001");
 * the registry turns them into cause + step-by-step resolution for admins.
 */
export interface ErrorCodeEntry {
  code: string;
  area: string;
  title: string;
  studentMessage: string;
  cause: string;
  adminSteps: string[];
  fixScreen?: { label: string; path: string };
}

class ErrorHelpService {
  private baseUrl = `${Config.nodeSiteUrl}v1/error-codes`;

  async lookup(code: string): Promise<ErrorCodeEntry> {
    const res = await myAxios.get(`${this.baseUrl}/${encodeURIComponent(code.trim())}`);
    return (res.data as any).data as ErrorCodeEntry;
  }

  async list(): Promise<ErrorCodeEntry[]> {
    const res = await myAxios.get(this.baseUrl);
    return ((res.data as any).data || []) as ErrorCodeEntry[];
  }
}

export default new ErrorHelpService();
